import { LanguageProvider } from '@app/hooks/context/LanguageContext';
import React, { useEffect } from 'react';

interface AppWrapperProps {
    children: React.ReactNode;
}

export default ({ children }: AppWrapperProps) => {
    useEffect(() => {
        const testingElement = document.createElement('div');
        testingElement.id = 'app-ready';
        testingElement.style.display = 'none'; // Hidden from user view
        document.body.appendChild(testingElement);

        // Clean-up function to remove this element on unmount:
        return () => testingElement.remove();
    }, []);

    return <LanguageProvider>{children}</LanguageProvider>;
};
